import type { ReactNode } from 'react';

interface SectionHeaderProps {
  label: string;
  meta?: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function SectionHeader({ label, meta, description, action }: SectionHeaderProps) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between gap-3">
        <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[rgba(26,26,26,0.42)] min-[430px]:text-[11px]">
          {label}
        </p>
        {meta || action ? (
          <div className="flex items-center gap-2">
            {meta ? (
              <p className="text-[11px] font-medium text-[rgba(26,26,26,0.5)] min-[430px]:text-[12px]">
                {meta}
              </p>
            ) : null}
            {action}
          </div>
        ) : null}
      </div>
      {description ? (
        <div className="text-[12px] leading-5 text-[rgba(26,26,26,0.56)]">{description}</div>
      ) : null}
    </div>
  );
}
